import React, { useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';
import { Form, Button } from 'react-bootstrap';
import notifier from '../../../_utils/notifier';
import { renderField } from '../common/FormsControls.jsx';
import { required } from '../../../_utils/validators';
import { LoginRequired } from '../../hoc/LoginRequired.jsx';
import { Page } from '../../hoc/Page.jsx';

import { createAphorism } from '../../actions/aphorisms';


const AphorismsForm = (props) => {
  const {anyTouched, invalid, submitting, handleSubmit} = props;
  let [redirect, setRedirect] = useState(false);
  const listView = `/${props.lang}/my/content/aphorisms/`

  const renderRedirect = () => {
    if (redirect) {
      return <Redirect to={ listView } />
    }
  }

  const handleReset = () => {
    setRedirect(true);
  }

  const handleSaveAndGo = (formData) => {
    handleSubmit(formData);
    notifier.success(gettext('Цитата/Фраза успешно добавлена. Она появится на сайте после прохождения модерации.'));
    setRedirect(true);
  };

  const handleFormSubmit = (formData) => {
    handleSubmit(formData);
    notifier.success(gettext('Цитата/Фраза успешно добавлена. Она появится на сайте после прохождения модерации.'));
  };

  return <div>
    { renderRedirect() }
    <Form onSubmit={ handleFormSubmit } className={'cabinet-form' + (anyTouched ? ' was-validate' : '')}>
      <Field component={ renderField }
             element="input"
             name='author'
             label={ gettext('Автор фразы') }
             placeholder={ gettext('Автор фразы') }
             helptext={ gettext('Оставьте это поле пустым, если вы являетесь автором этого высказывания.') }/>
      <Field placeholder={ gettext('Текст') }
             component={ renderField }
             required='required'
             element="textarea"
             name='content'
             label={ gettext('Текст') }
             validate={ [required] }/>
      <div className='text-lg-right'>
        <Button variant="outline-secondary" type='reset' onClick={ handleReset }
                className='mr-2 mt-2 mt-md-0'>{ gettext('Отменить') }</Button>
        <Button variant="primary" type="button" disabled={ submitting || invalid } className='mr-2 mt-2 mt-md-0'
                onClick={ handleSaveAndGo }>{ gettext('Сохранить') }</Button>
        <Button variant="primary" type="submit" disabled={ submitting || invalid }
                className='mt-2 mt-md-0'>{ gettext('Сохранить и добавить еще') }</Button>
      </div>
    </Form>
  </div>
};

let mapStateToProps = (state) => {
  return {
    lang: state.auth.lang,
  }
};

export default compose(
  connect(mapStateToProps, { onSubmit: createAphorism }),
  LoginRequired,
  Page,
  reduxForm({ form: 'aphorismForm' })
)(AphorismsForm);
